import { BASE_URL } from '../../../Constant';

export const API_CREATE_DOCUMENT_CATEGORY_PAGE_TRANSLATION: string = `${BASE_URL}/document/category/translation`;
export const API_UPDATE_DOCUMENT_CATEGORY_PAGE_TRANSLATION: string = `${BASE_URL}/document/category/translation/update`;
export const API_UPDATE_DOCUMENT_CATEGORY_PAGE_TRANSLATION_STATUS: string = `${BASE_URL}/document/category/translation/changeStatus`;
export const GET_SINGLE_DOCUMENT_CATEGORY_PAGE_TRANSLATION = (
    documentCategoryPageId: number,
    languageId: number,
): string =>
    `${BASE_URL}/document/category/translation/${documentCategoryPageId}/${languageId}`;
export const GET_ALL_ACTIVE_DOCUMENT_TEMPLATES = `${BASE_URL}/document/template/allActiveDocumentTemplates`;
export const API_IS_URL_EXISTS: string = `${BASE_URL}/document/category/translation/isUrlExist`;

export const DOCUMENT_CATEGORY_PAGE_TRANSLATION_STATUS_ACTIVE: number = 1;
export const DOCUMENT_CATEGORY_PAGE_TRANSLATION_STATUS_INACTIVE: number = 2;
export const DOCUMENT_CATEGORY_PAGE_TRANSLATION_STATUS_DELETED: number = 10;
